import SuperJSON from "superjson";
import Id from "../types/Id";

export default class GroupId extends Id<"group"> {}

SuperJSON.registerClass(GroupId, { identifier: "GroupId" });
